export enum ProductFiltersFieldId {
  Availability = 'availability',
  Size = 'size',
  Catalog = 'catalog',
  Subsite = 'subsite',
  StrategicType = 'strategictype',
}
